<template>
  <v-checkbox v-model="internalValue" v-bind="$attrs" v-on="$listeners"/>
</template>

<script>
//from the vuetify docs about v-checkbox: "These components must be used with the v-model prop as they do not maintain their own state."
//this component adds the internal state
export default {
  name: "StatefulCheckbox",
  props: {
    value: null
  },
  data() {
    return {
      internalValue: this.value
    }
  },
  watch: {
    value(new_value) {
      this.internalValue = new_value;
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/ui/StatefulCheckbox.vue